export enum ActivateOption {
  DELETE_WITHDRAWAL_FORM = 1,
  KEEP_WITHDRAWAL_FORM = 2,
}
